// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dyBj","image":"Header_image__KTjAk","name":"Header_name__oUYUC","info":"Header_info__2i8AB","infoRow":"Header_infoRow__2fzU2"};